import React from 'react';
import ExperienceRiskBadge from './ExperienceRiskBadge';

const ChurnRiskPanel = ({ records = [] }) => {
  const rows = [...records]
    .sort((a, b) => String(b.churnRiskLevel || '').localeCompare(String(a.churnRiskLevel || '')))
    .slice(0, 8);

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Risiko Churn</h3>
      <div className="mt-3 space-y-2">
        {rows.map((item) => (
          <div key={`churn-${item.customerId}`} className="rounded-lg border border-slate-800 bg-slate-950/60 p-2.5 text-xs text-slate-300">
            <div className="flex items-center justify-between">
              <div className="font-medium text-slate-100">{item.customerId}</div>
              <ExperienceRiskBadge level={item.churnRiskLevel} />
            </div>
            <div className="mt-1 text-slate-400">Area: {item.areaName || '-'}</div>
            <div className="mt-1 text-slate-400">{item.recommendedAction}</div>
          </div>
        ))}
        {!rows.length ? <div className="text-xs text-slate-500">Tidak ada churn risk tinggi.</div> : null}
      </div>
    </section>
  );
};

export default ChurnRiskPanel;
